export default "__VITE_PUBLIC_ASSET__c18ea905__"